import React from 'react';
import { Box } from '@mui/material';

const SvgIcon = ({ icon: Icon, color = '#FFFFFF', size = 24, width, height, sx, ...svgProps }) => {
  if (!Icon) {
    return null;
  }

  return (
    <Box
      component={Icon}
      sx={{
        width: width ?? size,
        height: height ?? size,
        color,
        display: 'inline-block',
        flexShrink: 0,
        '& path:not([fill="none"])': {
          fill: 'currentColor',
        },
        '& circle:not([fill="none"])': {
          fill: 'currentColor',
        },
        '& rect:not([fill="none"])': {
          fill: 'currentColor',
        },
        '& polygon:not([fill="none"])': {
          fill: 'currentColor',
        },
        '& ellipse:not([fill="none"])': {
          fill: 'currentColor',
        },
        '& [stroke]:not([stroke="none"])': {
          stroke: 'currentColor',
        },
        ...sx,
      }}
      {...svgProps}
    />
  );
};

export default SvgIcon;
